<template>
    <div class="main-content">
        <section class="non-app-page-width setting-profile-popup mfp-hide popup-save-document">
            <a @click="goToManage()" class="profile-edit-close-btn">
                <img src="/assets/img/close-icon.svg"/>
            </a>
            <div class="setting-profile-wrapper">
                <div class="save-document-form">
                    <h2>Let your colleagues join you</h2>
                    <p>Invite people to your team</p>
                    <form>
                        <div class="form-group">
                            <label for="TeamUrl" style="float: left;">Send people this link to let them join your team</label>
                            <input type="text" class="form-control" readonly :value="team_url"  id="TeamUrl">
                            <button class="btn btn-sm-alternative-primary copy-btn" type="button"
                                    @click="copyToClipboard()">{{ copyText }}</button>
                        </div>
                        <div class="form-group">
                            <label for="emails" style="float: left;">Or, invite them via email</label>
                            <textarea class="form-control" style="height: 160px;" rows="6" v-model="emails" id="emails" placeholder="Separate each email address with a comma"
                            @blur="validateEmail()"
                            ></textarea>
                            <div class="invalid-feedback" v-if="!valid_emails">Please ensure you have added a maximum of 25 valid email addresses and try again.</div>
                        </div>
                        <div class="form-group">
                            <input type="button" class="btn btn-primary mr-0 mt-3 mx-auto" @click="submit()" :disabled="busy" value="Continue">
                        </div>
                    </form>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import ApiService from "../../api/api.service";

export default {
    name: "TeamJoin",
    data() {
        return {
            busy: false,
            userData: null,
            team_url: null,
            team_id: null,
            team: null,
            emails: null,
            valid_emails: true,
            copyText: 'Copy',
        };
    },
    mounted() {
        this.getUser();
    },
    methods: {
        getUser() {
            this.userData = JSON.parse(localStorage.getItem('user'));
            if(this.userData.team_id) {
                this.team_id = this.userData.team_id;
                this.team = this.userData.team;
                this.team_url = process.env.MIX_APP_URL + '/teams/' + this.userData.team.uuid;
            }
        },

        goToManage() {
            this.$router.push({ name: 'Team Management'}); // team management
        },

        validateEmail() {
            let valid = true;
            if(this.emails) {
                let emails = this.emails.split(',')

                if(emails.length > 25) {
                    valid = false;
                } else {
                    let regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    for (let i = 0; i < emails.length; i++) {
                        if( emails[i] === "" || !regex.test(emails[i].replace(/\s/g, ""))){
                            valid = false;
                        }
                    }
                }
            } else {
                valid = false;
            }

            this.valid_emails = valid;
        },

        submit() {
            this.validateEmail();
            if(! this.emails || ! this.valid_emails) {
                return;
            }

            this.busy = true;

            let postData = {
                team_id: this.team_id,
                emails: this.emails
            };

            ApiService.setHeader();
            ApiService.post('/api/teams/invite', postData)
            .then(({data}) => {
                this.goToManage();
            })
            .catch((response) => {
                console.log(response);
            });
        },

        // Copy to clipboard
        copyToClipboard: function () {
            this.$copyText(this.team_url).then((e) => {
                this.copyText = 'Copied';

                // reset to normal after 2 seconds
                setTimeout(() => {
                    this.copyText = 'Copy';
                }, 2000)
            })
        }
    }
}
</script>

<style scoped>
.copy-btn {
    position: relative;
    top: -37px;
    right: -186px;
    margin: 0;
    border-radius: 20px;

    border: 1px solid #1e73bd;
    background-color: #1e73bd;
}

.copy-btn:hover {
    border: 1px solid #23a6cd;
    background-color: #23a6cd;
}
</style>
